{
  "name": "horizon-hub",
  "version": "9.7.0",
  "scripts": {
    "start": "ng s --port 4201 --host 0.0.0.0 --ssl true",
    "start:prod": "ng s --configuration=production --ssl true",
    "start:preprod": "ng s --configuration=preprod --ssl true",
    "start:local": "ng s --configuration=local --port 4201 --host 0.0.0.0 --ssl true",
    "start:backend": "cd ../../API/HUB && dotnet run --launch-profile Local",
    "start:staging": "ng s --configuration=staging --ssl true",
    "start:dev": "ng s --configuration=development --ssl true",
    "test": "ng test",
    "build": "ng build",
    "buildProd": "ng build --configuration=production",
    "buildPreProd": "ng build --configuration=preprod",
    "buildStaging": "ng build --configuration=staging",
    "buildDev": "ng build --configuration=development"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.13",
    "@angular/cdk": "^18.2.14",
    "@angular/common": "^18.2.13",
    "@angular/compiler": "^18.2.13",
    "@angular/core": "^18.2.13",
    "@angular/forms": "^18.2.13",
    "@angular/localize": "^18.2.13",
    "@angular/platform-browser": "^18.2.13",
    "@angular/platform-browser-dynamic": "^18.2.13",
    "@angular/router": "^18.2.13",
    "@fortawesome/angular-fontawesome": "^0.10.2",
    "@fortawesome/fontawesome-pro": "^6.5.2",
    "@fortawesome/fontawesome-svg-core": "^6.1.1",
    "@fortawesome/free-brands-svg-icons": "^6.1.1",
    "@fortawesome/free-regular-svg-icons": "^6.1.1",
    "@fortawesome/free-solid-svg-icons": "^6.1.1",
    "@fortawesome/pro-duotone-svg-icons": "^6.1.1",
    "@fortawesome/pro-light-svg-icons": "^6.1.1",
    "@fortawesome/pro-regular-svg-icons": "^6.1.1",
    "@fortawesome/pro-solid-svg-icons": "^6.1.1",
    "@ng-bootstrap/ng-bootstrap": "^17.0.1",
    "@ng-select/ng-select": "^13.9.1",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@popperjs/core": "^2.11.5",
    "@ryware/ngx-drag-and-drop-lists": "^3.1.0",
    "@swimlane/ngx-charts": "^20.1.0",
    "@types/googlemaps": "^3.43.3",
    "angular-datatables": "^13.0.1",
    "angular2-multiselect-dropdown": "^10.0.0",
    "bootstrap": "^5.1.3",
    "cli": "^1.0.1",
    "datatables-buttons": "^1.0.3",
    "datatables-responsive": "^1.0.7",
    "datatables.net": "^1.12.1",
    "datatables.net-buttons": "^2.2.3",
    "datatables.net-buttons-dt": "^2.2.3",
    "datatables.net-dt": "^1.12.1",
    "flag-icons": "^7.2.3",
    "jszip": "^3.10.0",
    "jwt-decode": "^3.1.2",
    "libphonenumber-js": "^1.10.6",
    "mixpanel-browser": "^2.68.0",
    "mobile-drag-drop": "^2.3.0-rc.2",
    "moment": "^2.30.1",
    "moment-range": "^4.0.2",
    "ng-qrcode": "^18.x.x",
    "ng-zorro-antd": "^18.2.1",
    "ngx-color": "^7.3.3",
    "ngx-drag-drop": "^18.0.2",
    "ngx-moment": "^6.0.2",
    "ngx-pagination": "^6.0.1",
    "ngx-permissions": "^13.0.1",
    "ngx-quill": "^26.0.10",
    "ngx-toastr": "^17.0.2",
    "pdfmake": "^0.3.1",
    "rxjs": "~7.5.5",
    "tslib": "^2.4.0",
    "underscore": "^1.13.6",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.12",
    "@angular-eslint/builder": "18.4.3",
    "@angular-eslint/eslint-plugin": "18.4.3",
    "@angular-eslint/eslint-plugin-template": "18.4.3",
    "@angular-eslint/schematics": "18.4.3",
    "@angular-eslint/template-parser": "18.4.3",
    "@angular/cli": "^18.2.12",
    "@angular/compiler-cli": "^18.2.13",
    "@angular/language-service": "^18.2.13",
    "@eslint/eslintrc": "^3.2.0",
    "@eslint/js": "^9.17.0",
    "@types/datatables.net": "^1.10.22",
    "@types/datatables.net-buttons": "^1.4.7",
    "@types/jasmine": "~4.0.3",
    "@types/jasminewd2": "~2.0.10",
    "@types/jquery": "^3.5.14",
    "@types/node": "^22.10.2",
    "@types/quill": "^2.0.14",
    "@typescript-eslint/eslint-plugin": "^7.2.0",
    "@typescript-eslint/parser": "^7.2.0",
    "jasmine-core": "~4.1.1",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.3.20",
    "karma-chrome-launcher": "~3.1.1",
    "karma-coverage": "^2.2.1",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~5.0.1",
    "karma-jasmine-html-reporter": "^2.0.0",
    "typescript": "5.4"
  }
}
